const servicesContent = [
  {
    slug: 'pharmacovigilance-system-setup',
    title: 'Pharmacovigilance System Setup',
    summary:
      'Design, implement, and optimize end-to-end PV systems that minimize risk and maximize patient safety while aligning to global regulations.',
    description:
      'Pharmacovigilance (PV) systems are a set of complex operations that must seamlessly work together to minimize risk and maximize patient safety. Diverse and ever-evolving regulations often make it difficult for pharmaceutical organizations to build and operate a compliant PV system. Leveraging Good Pharmacovigilance Practice as the foundation of our processes, we deliver comprehensive PV services that cater to organizations of every size. Our proven expertise across the PV spectrum and deep knowledge of global and local safety requirements enable us to rapidly scale for full PV delivery while setting new standards for quality and compliance.',
    features: [
      'System architecture design and roadmap',
      'Custom configuration for products, studies, and partners',
      'Regulatory compliance setup and validation support',
      'User access and governance frameworks',
      'Workflow and signal management customization',
      'Training and change-management enablement',
    ],
  },
  {
    slug: 'provision-of-safety-database',
    title: 'Provision of Safety Database',
    summary:
      'Deploy and maintain validated safety databases that simplify case processing, regulatory submissions, and ongoing data stewardship.',
    description:
      'A safety database is the digital backbone of a pharmacovigilance program—collecting, processing, and submitting individual case safety reports while supporting aggregate, signal, and other safety analyses. It must comply with stringent regulatory validation standards and be continually updated to align with changing guidelines and medical dictionaries. With deep implementation experience, we help customers select the right safety database, validation protocols, and hosting models to reduce implementation and maintenance costs. We provide expert guidance on interoperability, system upgrades, and dictionary management, and we can deliver hosting as a managed service.',
    features: [
      'End-to-end database deployment and validation',
      'Data structure and integration design',
      'High-availability hosting and managed services',
      'Backup, disaster recovery, and performance optimization',
      'Regulatory and dictionary upgrade management',
      'Interoperability and API enablement',
    ],
  },
  {
    slug: 'audit-and-inspection-support',
    title: 'Audit and Inspection Support',
    summary:
      'Prepare confidently for global PV audits and inspections with proactive readiness assessments, remediation, and live support.',
    description:
      'Successful audits and inspections require proactive readiness, robust documentation, and confident execution. We partner with your teams to perform gap assessments, implement corrective and preventive actions, and provide on-site or remote support during regulatory inspections. Our experts bring first-hand experience with global health authorities, equipping you with the tools, templates, and responses needed to navigate audits with confidence.',
  bannerImage: '/auditandInspection1.jpg',
    features: [
      'End-to-end audit readiness assessments',
      'CAPA planning and implementation',
      'Mock inspections and documentation reviews',
      'On-site/remote support during health authority inspections',
      'Post-inspection remediation and monitoring',
      'Training for PV teams and partners',
    ],
  },
  {
    slug: 'qppv-services',
    title: 'QPPV Services',
    summary:
      'Access seasoned Qualified Persons for Pharmacovigilance who provide governance, oversight, and strategic leadership across regions.',
    description:
      'Our QPPV services ensure that your safety organization meets regulatory expectations for governance, oversight, and strategic leadership. Experienced QPPVs provide 24/7 availability, interface with health authorities, and oversee the continuous improvement of your PV system. From risk management plans to signal strategies, we help you demonstrate robust compliance across the product lifecycle.',
    features: [
      'Global/local QPPV representation and availability',
      'PV system governance and oversight',
      'Regulatory authority engagement and reporting',
      'Risk management plan development and maintenance',
      'Signal detection and benefit–risk evaluation support',
      'Inspection readiness and CAPA leadership',
    ],
  },
  {
    slug: 'pharmacovigilance-system-master-file',
    title: 'Pharmacovigilance System Master File (PSMF)',
    summary:
      'Build and maintain accurate PSMFs that reflect your PV system, affiliates, and partners—ready for inspection at any time.',
    description:
      'A current and well-governed Pharmacovigilance System Master File is essential for demonstrating compliance. We help you establish the processes, templates, and governance needed to keep PSMFs and annexes up to date, aligned with organizational changes, and inspection-ready. Our specialists coordinate with affiliates, partners, and vendors to ensure every element of your PV system is accurately captured.',
    features: [
      'PSMF authoring, updates, and controlled distribution',
      'Annex management across affiliates and partners',
      'Governance frameworks and change control',
      'Data collection from internal and external stakeholders',
      'Inspection-ready formatting and traceability',
      'Ongoing maintenance and periodic review cycles',
    ],
  },
  {
    slug: 'sdea-management',
    title: 'Safety Data Exchange Agreements (SDEA) Management',
    summary:
      'Create, negotiate, and monitor SDEAs that clearly define PV responsibilities, data flows, and timelines for every partnership.',
    description:
      'Effective SDEA management ensures that pharmacovigilance obligations are clearly defined, monitored, and fulfilled across all partners. We manage the full SDEA lifecycle—from drafting and negotiation to periodic reviews and deviation handling—so that oversight remains robust as partnerships evolve. Our team ensures timely safety data exchange, compliance with regulatory timelines, and transparent communication between parties.',
    features: [
      'SDEA drafting, review, and negotiation support',
      'Role/responsibility mapping and governance',
      'Safety data exchange workflows and tooling',
      'Monitoring of compliance metrics and obligations',
      'Periodic SDEA audits and updates',
      'Deviation management and CAPA tracking',
    ],
  },
  {
    slug: 'safety-data-migration-assistance',
    title: 'Safety Data Migration Assistance',
    summary:
      'Plan and execute complex safety data migrations—mergers, divestitures, upgrades—with zero compromise on quality or compliance.',
    description:
      'M&A activity, technology upgrades, and organizational change often require large-scale safety data migration across cases, products, and historical reports. Our experts analyze source and target systems, define mapping and transformation rules, and execute controlled migrations with comprehensive validation. We help clients de-risk transition periods while preserving data integrity, regulatory compliance, and business continuity.',
    features: [
      'Migration strategy, planning, and governance',
      'Data mapping, transformation, and cleansing',
      'Automated validation and reconciliation checks',
      'Support for ICSRs, aggregate, signal, and product data',
      'Parallel run management and go-live support',
      'Post-migration monitoring and optimization',
    ],
  },
  {
    slug: 'literature-translation-and-full-text',
    title: 'Literature Translation & Full-Text Procurement',
    summary:
      'Streamline global literature surveillance with rapid translation, full-text acquisition, and local requirements expertise.',
    description:
      'Medical and scientific literature remains a critical source of safety information, but varying regional requirements make surveillance challenging. We provide multilingual literature translation, rapid full-text procurement, and local search support to keep you compliant with global and country-specific guidelines. Our teams ensure that ICSRs, aggregate reports, signal assessments, and other safety outputs are fully supported with accurate literature evidence.',
    features: [
      'Translation of medical and scientific literature within tight timelines',
      'Full-text procurement for global and local journals',
      'Support for ICSRs, aggregate, and signal deliverables',
      'Local literature search strategy and execution',
      'Quality review and medical accuracy checks',
      'Integration with literature monitoring workflows',
    ],
  },
];

export default servicesContent;

